import { MemoryRouter } from "react-router-dom";
import { ReactNode } from "react";

/**
 * Compatibility wrapper for @floriday/floriday-ui components
 * that internally depend on react-router-dom context.
 *
 * This provides the necessary Router context for UI library components
 * while the app uses TanStack Router for actual routing.
 * 
 * Uses MemoryRouter instead of BrowserRouter to avoid interfering with
 * TanStack Router's URL management and to prevent state updates during render.
 */
export function FloridayUIRouterCompat({ children }: { children: ReactNode }) {
  return <MemoryRouter>{children}</MemoryRouter>;
}
